<template>
    <article>
        <p class="text-grey-70 pb-2">The services of good recruitment agencies can save businesses time
            and money, as well as ensure that job hunters find the right position as quickly as
            possible. However, recruitment agencies do much more than simply match candidates to
            vacancies. Most agencies (who are also referred to as Employment Agencies or Job Agencies)
            focus their efforts on a small number of industries and specific geographic area, so develop
            genuine expertise in their market. Both employers and people looking for new jobs can expect
            the consultant they deal with to offer accurate salary advice and have the right contacts in
            the sector.</p>
        <p class="text-grey-70 pb-2">There are many benefits to candidates of dealing with recruitment
            consultants, including saving time and having someone to negotiate their salary package.
            Agencies also usually have a selection of unadvertised vacancies that job hunters can gain
            access to when they register. Time is a major motivation for companies to use recruitment
            agencies, as a consultant will only put forward shortlists of staff with the right skills
            and experience. As agencies have relationships with a wide range of candidates, including
            some they have worked with for a number of years, they can also make sure interviewees are a
            good cultural fit for the organisation. When working on permanent jobs, agencies usually
            only charge if they fill the vacancy, so this is a low-risk way to recruit workers. Even if
            they do not earn a fee, agencies will complete the task of informing unsuccessful candidates
            and pass on feedback from interviews. Employment agencies are also an effective way to fill
            temporary positions and not only because they can supply experienced, reference-checked
            staff with the right skills. They can also take care of all payroll issues, including
            holiday pay.</p>
        <p class="text-grey-70">In short, using a recruitment agency is the right choice for
            businesses that need to find the best staff and jobseekers who want to secure their ideal
            position in the shortest possible time.</p>
    </article>
</template>

<script>
export default {
    name: "WhyUseAgencyInfo"
}
</script>
